export default function(data) {

	return new Promise(function (resolve, reject) {

		const xhr = new XMLHttpRequest();
		xhr.addEventListener("readystatechange", function () {
			if (this.readyState === this.DONE) {

				try {
					let response = JSON.parse(this.responseText);
					resolve(response.body_response.dates);
				} catch(error) {
					resolve(error);
				}
			}
		});

		xhr.open("GET", '/wp-json/laserred/dates/restricted-dates');
		xhr.setRequestHeader("Accept", "*/*");
		xhr.setRequestHeader("Content-Type", "application/json");

		xhr.send();
	});
}